export interface UrlRankRequest {
  keyword: string;
  product_url: string;
  force_refresh?: boolean;
}

export type UrlRankCheckStatus =
  | 'stored_complete'
  | 'pending'
  | 'running'
  | 'complete'
  | 'partial'
  | 'failed';

/** POST 200: 오늘 저장 순위가 있는 경우 */
export interface UrlRankStoredResponse {
  keyword: string;
  product_url: string;
  rank: number | null;
  nv_mid: string | null;
  rank_check_status: 'stored_complete';
  search_range: number;
  source: string;
  organic_only: boolean;
  rank_date: string;
}

/** POST 202: 백그라운드 작업 생성 */
export interface UrlRankJobAccepted {
  job_id: string;
  rank_check_status: 'pending';
  rank: null;
  search_range: number;
  status_url: string;
}

/** GET /utils/url-rank/{job_id}/ 진행/결과 */
export interface UrlRankJobStatus {
  job_id?: string;
  keyword?: string;
  product_url?: string;
  rank: number | null;
  nv_mid?: string | null;
  rank_check_status: UrlRankCheckStatus;
  search_range?: number;
  source?: string;
  organic_only?: boolean;
  rank_date?: string;
  checked_products?: number;
  elapsed_ms?: number;
  detail?: string;
  message?: string;
}

export type UrlRankResult = UrlRankStoredResponse | UrlRankJobStatus;

export type UrlRankStartResult =
  | { kind: 'stored'; data: UrlRankStoredResponse }
  | { kind: 'job'; data: UrlRankJobAccepted };

export interface UrlRankError {
  type: 'VALIDATION_ERROR' | 'API_ERROR' | 'TIMEOUT_ERROR';
  message: string;
  details?: string;
}

export const URL_RANK_POLL_INTERVAL_MS = 3000;

export function isTerminalUrlRankStatus(status: UrlRankCheckStatus): boolean {
  return status === 'complete' || status === 'partial' || status === 'failed' || status === 'stored_complete';
}
